<template>
  <div class="customer-detail">
    <div class="customer-header pt-0" >
      <slot name="header"></slot>

      <div class="text-xs-center">
        <v-avatar size="100">
          <v-img
            :lazy-src="user.profile_pic"
            :src="user.profile_pic"
            aspect-ratio="1"
            class="grey lighten-2"
          >
            <template v-slot:placeholder>
              <v-layout fill-height align-center justify-center ma-0>
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-layout>
            </template>
          </v-img>
        </v-avatar>
        <div class="text-xs-center mt-2" style="color: white">
          {{ user.first_name ? user.first_name : '' }} {{ user.last_name ? user.last_name : '' }}
        </div>
        <div class="mb-4 text-xs-center">
          <v-btn
            :href="'https://business.facebook.com' + user.inboxurl"
            target="_blank"
            small
            depressed
            round
            color="#3b5998"
            dark
            v-if="user.app == 'facebook' && user.inboxurl"
          >
            <i class="fab fa-facebook-square mr-1"></i>
            {{ $t('View inbox') }}
          </v-btn>

          <template v-if="['ecommercebasic'].includes(selectedBot.theme) && shoplink">
            <v-btn :href="shoplink" target="_blank" small depressed round outline dark>
              <v-icon class="mr-1" small>shopping_cart</v-icon>
              {{ $t('Create order') }}
            </v-btn>
          </template>
        </div>
      </div>
    </div>
    <template v-if="!loading">
      <div v-if="selectedBot.theme == 'sahapan'" class="text-xs-right">
        <sahapan-add-manual :user="user"></sahapan-add-manual>
      </div>
      <v-layout wrap>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Channel') }}</label>
          <p>
            <span style="color: #3b5998" v-if="user.app == 'facebook'">
              <i class="fab fa-facebook-square"></i> Facebook
            </span>
            <span style="color: #00c300" v-else-if="user.app == 'line'">
              <i class="fab fa-line"></i> Line
            </span>
          </p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('gender') }}</label>
          <p>{{ $t(user.gender) }}</p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Locale') }}</label>
          <p>
            <template v-if="userLocale">
              <flag :iso="userLocale.icon" />
              {{ userLocale.title }}
            </template>
            <template v-else>-</template>
          </p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption">
            {{ $t('Status') }}
            <v-premium-lock :inline="true"></v-premium-lock>
          </label>
          <div>
            <p>
              <edit-customer-value
                v-if="selectedBot.theme == 'centralhr'"
                v-model="user['status']"
                :userid="user.id"
                :placeholder="$t('Status')"
                @onEdit="onEditStatus"
                :type="'dropdown'"
                :options="['Resign', 'Rehire']"
              >
                <customer-item-value :value="user['status']">{{ user.status }}</customer-item-value>
              </edit-customer-value>
              <edit-customer-value
                v-else
                v-model="user['status']"
                :userid="user.id"
                :placeholder="$t('Status')"
                @onEdit="onEditStatus"
              >
                <customer-item-value :value="user['status']">{{ user.status }}</customer-item-value>
              </edit-customer-value>
            </p>
          </div>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption">
            {{ $t('Address') }}
            <v-premium-lock :inline="true"></v-premium-lock>
          </label>
          <div>
            <p>
              <edit-customer-value
                v-model="user['address']"
                :userid="user.id"
                :placeholder="$t('Address')"
                @onEdit="onEditAddress"
              >
                <customer-item-value :value="user['address']">{{
                  user.address
                }}</customer-item-value>
              </edit-customer-value>
            </p>
          </div>
        </v-flex>
      </v-layout>

      <v-divider></v-divider>

      <v-layout wrap>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Register Date') }}</label>
          <p>
            {{ user.registertimestamp ? getFormatDate(user.registertimestamp, 'DD/MM/YYYY') : '-' }}
          </p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Last Active Date') }}</label>
          <p>{{ user.timestamp ? getFormatDate(user.timestamp, 'DD/MM/YYYY') : '-' }}</p>
        </v-flex>

        <!-- <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Email') }}</label>
          <p>
            <edit-customer-value
              v-model="user['email']"
              :userid="user.id"
              :placeholder="$t('Email')"
              @onEdit="onEditEmail"
            >
              <customer-item-value :value="user['email']">{{ user.email }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('phone no.') }}</label>
          <p>
            <edit-customer-value
              v-model="user['phoneno']"
              :userid="user.id"
              :placeholder="$t('phone no.')"
              @onEdit="onEditPhone"
            >
              <customer-item-value :value="user['phoneno']">{{ user.phoneno }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex> -->

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Context') }}</label>
          <p>
            <edit-customer-value
              v-model="user['context']"
              :userid="user.id"
              :placeholder="$t('Context')"
              @onEdit="onEditContext"
            >
              <customer-item-value :value="user['context']">{{ user.context }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>
      </v-layout>

      <v-divider></v-divider>

      <v-layout wrap>
        <v-flex class="pl-3 pt-2 pb-2" xs12>
          Depa member
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>membername</label>
          <p>
            {{ user.membername || '-' }}
          </p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>phone no.</label>
          <p>
            {{ user.memberphone || '-' }}
          </p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>email</label>
          <p>
            {{ user.memberemail || '-' }}
          </p>
        </v-flex>
      </v-layout>

      <v-layout wrap v-if="selectedBot.theme == 'sahapan'">
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Real First Name') }}</label>
          <p>
            <edit-customer-value
              v-model="user['realfirstname']"
              :userid="user.id"
              :placeholder="$t('Real First Name')"
              @onEdit="saveSahapanUserProfile('realfirstname', $event)"
            >
              <customer-item-value :value="user['realfirstname']">{{
                user.realfirstname
              }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Real Last Name') }}</label>
          <p>
            <edit-customer-value
              v-model="user['reallastname']"
              :userid="user.id"
              :placeholder="$t('Real Last Name')"
              @onEdit="saveSahapanUserProfile('reallastname', $event)"
            >
              <customer-item-value :value="user['reallastname']">{{
                user.reallastname
              }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Date of Birth') }}</label>
          <p>
            <edit-customer-value
              v-model="user['dob']"
              :userid="user.id"
              :placeholder="$t('Date of Birth')"
              type="date"
              @onEdit="saveSahapanUserProfile('dob', $event)"
            >
              <customer-item-value :value="user['dob']">
                <template v-if="user.dob">{{ user.dob | DateFormat('DD/MM/YYYY') }}</template>
                <template v-else>-</template>
              </customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>
        <v-flex xs12 sm6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Address') }}</label>
          <p>
            <edit-customer-value
              v-model="user['address']"
              :userid="user.id"
              :placeholder="$t('Address')"
              @onEdit="saveSahapanUserProfile('address', $event)"
            >
              <customer-item-value :value="user['address']">{{ user.address }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>
      </v-layout>

      <v-divider></v-divider>

      <div class="pl-3 pr-3 pt-2 pb-2">
        <label class="caption" for>
          {{ $t('Tag') }}
          <v-premium-lock :inline="true"></v-premium-lock>
        </label>

        <a
          href="javascript:void(0);"
          v-if="$store.getters.getPackage == 'premium' && !isEditTag"
          @click="editTag"
        >
          <i class="fa fa-pencil-alt middle"></i>
        </a>
      </div>
      <div class="pl-3 pr-3 pt-2 pb-2">
        <template v-if="!isEditTag">
          <div class="left-align" v-if="tags.length == 0">{{ $t('No tag') }}</div>
          <ul class="tags">
            <li class="tag" v-for="(tag, index) in tags" :key="'usertag_' + index">
              <specialtext :text="tag"></specialtext>
            </li>
          </ul>
        </template>
        <template v-else>
          <tags
            v-model="usertag"
            :tags="usertags"
            @tags-changed="addUserTags"
            @before-adding-tag="checkUserTags"
            style="margin-bottom: 5px"
            :btnText="$t('Add tag')"
          ></tags>

          <div class="text-xs-center" style="margin-top: 15px">
            <v-btn outline color="grey" small @click="cancelEditTag">{{ $t('cancel') }}</v-btn>
            <v-btn depressed color="primary" small @click="saveEditTag">{{ $t('Save') }}</v-btn>
          </div>
        </template>
      </div>

      <v-divider></v-divider>
      <div class="pl-3 pr-3 pt-2 pb-2" v-if="userSession">
        <div class="mb-2">
          <label class="caption">
            {{ $t('Data Summary') }}
          </label>
          <a href="javascript:void(0);" v-if="!isEditSession" @click="isEditSession = true">
            <i class="fa fa-pencil-alt middle"></i>
          </a>
        </div>
        <template>
          <div
            v-if="typeof userSession === 'object'"
            style="
              overflow-y: auto;
              max-height: 300px;
              padding: 5px;
              background: #f7f7f7;
              border: 1px solid #eee;
              border-radius: 5px;
            "
          >
            <template>
              <template>
                <div
                  :key="`key${index}`"
                  v-for="(value, name, index) in userSession"
                  style="padding: 10px; margin: 5px 0; border: 1px solid #eee; background: white"
                >
                  <v-btn icon v-if="isEditSession" style="float: right" @click="deleteSession(name)"
                    ><v-icon color="primary">delete</v-icon></v-btn
                  >
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <template>
                        <span style="color: #ff706b">{{ name }}</span></template
                      ></v-flex
                    >
                    <v-flex xs12 sm6 class="form-control">
                      <template v-if="!isEditSession">{{ value }}</template>
                      <input v-else type="text" v-model="userSession[name]"
                    /></v-flex>
                  </v-layout>
                </div>
              </template>
            </template>
          </div>
          <div v-else>
            <p>{{ userSession }}</p>
          </div>
          <div class="text-xs-center mt-2" v-if="isEditSession">
            <v-btn outline color="grey" small @click="cancleEditSession">{{ $t('cancel') }}</v-btn>
            <v-btn depressed color="primary" small @click="editSession">{{ $t('Save') }}</v-btn>
          </div>
        </template>
      </div>
      <v-divider v-if="userSession"></v-divider>
      <div v-if="!getuseronly" class="pl-3 pr-3 pt-2 pb-2">
        <label class="caption" for>{{ $t('Message Sent') }}</label>
        <div style="position: relative" margin-top="25">
          <div v-if="!selectedBot.status">
            <div class="text-xs-center my-3">
              <v-card
                max-width="600"
                style="margin: auto; border-radius: 10px"
                flat
                class="grey lighten-4"
              >
                <v-card-text>
                  <h3 style="text-shadow: 1px 1px 20px #9e9e9e" class="display-1">
                    {{ $t('If you want to test, please activate your bot') }}
                  </h3>
                  <p>
                    {{
                      $t('Information will not be recorded in analytics if the bot is inactivated')
                    }}
                  </p>

                  <v-btn
                    depressed
                    style="margin-bottom: 1.5em"
                    @click="toggleBotStatus"
                    small
                    color="primary"
                    >{{ $t('Click for starting your Bot') }}</v-btn
                  >
                </v-card-text>
              </v-card>
            </div>
          </div>
          <template v-else>
            <v-premium-plan-popup
              :showAll="false"
              v-if="$store.getters.getPackage != 'premium'"
            ></v-premium-plan-popup>
            <div
              style="
                overflow-y: auto;
                max-height: 300px;
                padding: 5px;
                background: #f7f7f7;
                border: 1px solid #eee;
                border-radius: 5px;
              "
            >
              <template v-if="$store.getters.getPackage != 'premium'">
                <div
                  v-for="(intent, index) in 10"
                  :key="'intent_' + index"
                  style="padding: 10px; margin: 5px 0; border: 1px solid #eee; background: white"
                >
                  <div
                    style="
                      height: 15px;
                      position: relative;
                      top: 3px;
                      display: inline-block;
                      width: 100%;
                      max-width: 100px;
                      background-color: #eee;
                    "
                  ></div>
                </div>
              </template>
              <template v-else>
                <template v-if="filterIntent.length > 0">
                  <div
                    v-for="(intent, index) in filterIntent"
                    :key="'intent_' + index"
                    style="padding: 10px; margin: 5px 0; border: 1px solid #eee; background: white"
                  >
                    <template v-if="$store.getters.getPackage == 'premium'">
                      <template v-if="intent[0] === '{default}'">{{
                        $t('Default Conversation')
                      }}</template>
                      <template v-else-if="intent[0] === '{welcome}'">{{
                        $t('Welcome Message')
                      }}</template>
                      <template v-else-if="intent[0] === '{default_comment_to_inbox}'">{{
                        $t('More Comment to Inbox')
                      }}</template>
                      <template v-else-if="intent[0] == null">{{ $t('Other') }}</template>
                      <template v-else>{{ intent[0] }}</template>
                      ({{ intent[1] | numberFormat }})
                    </template>
                  </div>
                </template>
                <template v-else>
                  <div class="text-xs-center">{{ $t('No message sent') }}</div>
                </template>
              </template>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import CustomerDetail from './CustomerDetail.js'

export default {
  mixins: [CustomerDetail]
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/CustomerDetail.vue